import { connect } from 'react-redux';

import Journey from './Journey';
import AllChips from './JourneyChips';
import {
  goToEducatorArea,
  goToAssignments,
  goToMaterials,
  goToEngagementInsights,
} from '../../../../actions/navigation';
import { journeyTab } from '../../../../selectors/routing';
import {
  currentClassRoomId,
  classRoomName,
  isInstructor,
  accessingCurrentSpaceAsStaff,
} from '../../../../../core/selectors/classroom';

import { currentUser } from '../../../../../core/selectors/user';

import { selectors as materialsSelectors } from '../../../../store/materials';

import { engagementInsightsEnabled } from '../../../../../core/selectors/institution';

const visibleChips = ({ isEducator, isStaff, enableEngagementInsights }) =>
  AllChips.filter((chip) =>
    chip.visible({ isEducator, isStaff, enableEngagementInsights })
  );
const educatorOnlyTab = (chipId) => chipId === 'educatorArea';

const mapStateToProps = (state) => {
  const user = currentUser(state);
  const isEducator = isInstructor(state, user.objectId);
  const isStaff = accessingCurrentSpaceAsStaff(state);

  return {
    chips: visibleChips({
      isEducator,
      isStaff,
      enableEngagementInsights: engagementInsightsEnabled(state),
    }),
    currentChipId: journeyTab(state),
    spaceId: currentClassRoomId(state),
    currentSpaceName: classRoomName(state),
    firstMaterialId: materialsSelectors.getFirstMaterialId(state),
    firstEducatorMaterialId: materialsSelectors.getFirstEducatorMaterialId(
      state
    ),
  };
};

const ChipToAction = {
  materials: goToMaterials,
  assignments: goToAssignments,
  educatorArea: goToEducatorArea,
  engagement: goToEngagementInsights,
};

const mapDispatchToProps = (dispatch) => ({
  onChipChange: (chips, newChipIndex, spaceId, firstMaterialId) => {
    const chipId = chips.find((chip) => chip.id === newChipIndex).id;
    const action = ChipToAction[chipId];
    dispatch(action(spaceId, firstMaterialId));
  },
});

const mergeProps = (
  {
    chips,
    spaceId,
    firstMaterialId,
    firstEducatorMaterialId,
    ...otherStateProps
  },
  { onChipChange, ...otherDispatchProps },
  ownProps
) => ({
  ...otherStateProps,
  ...otherDispatchProps,
  ...ownProps,
  chips,
  onChipChange: (newChipIndex) => {
    const materialId = educatorOnlyTab(newChipIndex)
      ? firstEducatorMaterialId
      : firstMaterialId;
    return onChipChange(chips, newChipIndex, spaceId, materialId);
  },
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
  mergeProps
)(Journey);
